import { DAY_OF_WEEK, MEMBERSHIP_TEMPLATE_CATEGORY } from 'src/features/membershipType/types';

import * as z from 'zod';
import { entityFormFieldSchema } from 'src/features/entity/formSchema';

export type MembershipFormSchemaValues = z.infer<typeof membershipFormSchema>;
export const membershipFormSchema = entityFormFieldSchema.extend({
    name: z.string(),
    valid_from: z.string(),
    membership_type: z.string(),
    max_allowed_spaces_count: z.number(),
    valid_to: z.string().nullish(),
    membership_allowed_times: z
        .array(
            z.object({
                day_of_week: z.enum(DAY_OF_WEEK),
                from_time: z.string(),
                to_time: z.string(),
            }),
        )
        .nullish(),
});

export type CustomMembershipFormSchemaValues = z.infer<typeof customMembershipSchema>;
export const customMembershipSchema = membershipFormSchema.extend({
    site: z.string(),
    has_pricing_plan: z.boolean().nullish(),
    pricing_plan_identity: z.string().nullish(),
    apply_pricing_per_space: z.boolean().nullish(),
    auto_renew: z.boolean().nullish(),
    limit_duration: z.boolean().nullish(),
    limit_spaces: z.boolean().nullish(),
    max_allowed_spaces_count: z.number(),
    category: z.enum(MEMBERSHIP_TEMPLATE_CATEGORY),
    allow_extra_visitors: z.boolean().nullish(),
    max_extra_visitors_count: z.number().int().min(0).nullish(),
    allow_access_over_capacity_limit: z.boolean().nullish(),
    contribute_to_available_spaces: z.boolean().nullish(),
    allow_access_as_client_outside_restrictions: z.boolean().nullish(),
    limit_to_roles: z.array(z.string()).nullish(),
    duration: z.number().int().min(0).nullish(),
});
